import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ trail }) {
  return (
    <div className="breadcrumb" data-testid="breadcrumb">
      {trail.map((t, i) => (
        <React.Fragment key={i}>
          {t.to ? <Link to={t.to}>{t.label}</Link> : <span style={{ color: "var(--ink)" }}>{t.label}</span>}
          {i < trail.length - 1 ? <span>/</span> : null}
        </React.Fragment>
      ))}
    </div>
  );
}
